<h1 class="mb-4 wizard-h1">{{ welcome3_creating_demodata_title }}</h1>
<p class="mb-12">{{ welcome3_creating_demodata_text1 }}<br /></p>

<div style="width: 200px">
    <p-progressBar class="mt-4" mode="indeterminate" strokeColor="#0fb941"></p-progressBar>
</div>
